import { InsightsHubArticle } from "@insightsHub/models/insightsHubArticle.model";

const isNumericId = (value: string): boolean => /^\d+$/.test(value);

export const getInsightsHubArticleRouteId = (article: InsightsHubArticle): string =>
  article.documentId ?? String(article.id);

export const findInsightsHubArticleByRouteId = (
  articles: InsightsHubArticle[] | null | undefined,
  routeId: string
): InsightsHubArticle | undefined =>
  (articles ?? []).find((article) => article.documentId === routeId || String(article.id) === routeId);

export const resolveInsightsHubArticleDocumentId = (
  routeId: string,
  articles: InsightsHubArticle[] | null | undefined
): string => {
  const match = findInsightsHubArticleByRouteId(articles, routeId);

  if (match?.documentId) {
    return match.documentId;
  }

  if (!isNumericId(routeId)) {
    return routeId;
  }

  return routeId;
};
